import { StandardOrderProduct } from "shared/api/middleware-api-client";
import Text from "shared/ui/typography/Text";
import { getFormattedPrice } from "shared/utils/getFormattedPrice";

interface ProductItemPriceProps {
  product: StandardOrderProduct;
  className?: string;
}

const StandardProductItemPrice = ({
  product,
  className,
}: ProductItemPriceProps) => {
  return (
    <div className={className}>
      <Text className="gg-font-bold gg-text-lg">
        {getFormattedPrice(product.totalPrice * product.amount)}
      </Text>
      <Text className="gg-text-xs gg-text-dark-blue-800">Inclusief btw</Text>
    </div>
  );
};
export default StandardProductItemPrice;
